import { createMuiTheme, CssBaseline, ThemeProvider } from '@material-ui/core';
import { render } from 'react-dom';

import Main from './components/Main';

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        margin: '0.8em 0',
      },
    },
  },
  palette: {
    // primary: {
    //   main: '#234823',
    //   light: '#ff7961',
    //   dark: '#ff0000',
    //   contrastText: '#ff0000',
    // },
    // secondary: {
    //   main: '#3c7b3c',
    // },
    // text: {
    //   primary: '#000',
    //   secondary: '#FFF',
    //   disabled: '#333',
    //   hint: '#333',
    // },
  },
});

render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Main />
  </ThemeProvider>,
  document.getElementById('root')
);
